export const TA_CATEGORIES = [
  "Computers & PCs",
  "PC Care & Troubleshooting",
  "Printers, Toner & Ink",
  "Networking",
  "CCTV",
  "UPS & Power",
  "Small Business Technology",
];

export const categorySlug = (name) =>
  name
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const categoryFromSlug = (slug) => TA_CATEGORIES.find((c) => categorySlug(c) === slug);
